import React from 'react'
import { ContactInformationStyles } from './Styles'
import ContactInformation from '../../components/ContactInformation'
import ImageFacebook from "../../../../assets/icons/facebook.png";
import ImageTwitter from "../../../../assets/icons/twitter.png";
import ImageInstagram from "../../../../assets/icons/instagram.png";

const ContactInformationMobile = () => {
    return (
        <ContactInformationStyles>
            <ContactInformation socialNetworks = {[ImageFacebook, ImageInstagram, ImageTwitter]}/>
        </ContactInformationStyles>
    )
}

export default ContactInformationMobile